module.exports = __webpack_public_path__ + "img/IdeaspaceLogo.78984aa8.png";